(function () {
  function formatMoney(cents) {
    if (window.theme && theme.Currency && theme.Currency.formatMoney) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function routes() {
    return (window.theme && theme.routes) || {};
  }

  function itemPrice(item) {
    return typeof item.final_line_price === 'number' ? item.final_line_price : item.line_price;
  }

  function CartRewardsBar(el) {
    this.el = el;

    var dataEl = el.querySelector('[data-rewards-data]');
    if (!dataEl) return;

    try {
      this.config = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    // Tiers keep the order they're arranged in the theme editor (left to right),
    // which is also the order their icons are laid out in the DOM.
    this.tiers = (this.config.tiers || []).slice();

    // Thresholds are authored in the shop currency (AUD), but /cart.js totals
    // arrive in the shopper's presentment currency. Scale the thresholds by
    // Shopify's own conversion rate so a US shopper's $150 AUD tier isn't
    // silently treated as USD 150.
    var rate = window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate);
    if (rate && isFinite(rate) && rate > 0 && rate !== 1) {
      this.tiers = this.tiers.map(function (tier) {
        var scaled = Object.assign({}, tier);
        scaled.threshold_cents = Math.round(tier.threshold_cents * rate);
        return scaled;
      });
    }

    this.fillEl = el.querySelector('[data-rewards-fill]');
    this.messageEl = el.querySelector('[data-rewards-message]');

    this.tierEls = {};
    el.querySelectorAll('[data-tier-id]').forEach(function (tierEl) {
      this.tierEls[tierEl.dataset.tierId] = tierEl;
    }.bind(this));

    this.busy = false;
    this.pending = false;

    // When the bar is shown in more than one place (drawer + cart page),
    // only the first instance manages free-gift add/remove so gifts can't
    // be added twice. Every instance still renders the progress display.
    if (!CartRewardsBar.giftOwner) {
      CartRewardsBar.giftOwner = this;
    }

    this.refresh();

    document.addEventListener('ajaxProduct:added', this.refresh.bind(this));
    document.addEventListener('cart:updated', this.refresh.bind(this));
  }

  CartRewardsBar.prototype.getSubtotal = function (cart) {
    return cart.items.reduce(function (sum, item) {
      if (item.properties && item.properties._reward_tier) return sum;
      return sum + itemPrice(item);
    }, 0);
  };

  CartRewardsBar.prototype.refresh = function () {
    if (this.busy) {
      this.pending = true;
      return;
    }
    this.busy = true;

    var url = routes().cart || '/cart.js';
    fetch(url, { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(this.handleCart.bind(this))
      .catch(function () {})
      .then(function () {
        this.busy = false;
        if (this.pending) {
          this.pending = false;
          this.refresh();
        }
      }.bind(this));
  };

  CartRewardsBar.prototype.handleCart = function (cart) {
    var subtotal = this.getSubtotal(cart);
    // Hide the bar when nothing in the cart ships, e.g. only the $50 lash
    // consultation (Shirley, 30 Sep 2026). Reward gifts, $0 lines and
    // Shipping Protection don't count as shippable.
    var ships = cart.items.some(function (item) {
      return item.requires_shipping !== false && itemPrice(item) > 0 &&
        !(item.properties && (item.properties._reward_tier || item.properties._shipping_protection)) &&
        item.handle !== 'shipping-protection';
    });
    this.el.style.display = ships ? '' : 'none';
    this.render(subtotal);
    return this.syncGifts(cart, subtotal);
  };

  // Icons sit in equal-width flex columns, so tier i (0-indexed) of n is
  // centered at (2i+1)/(2n) of the track's width. The fill has to line up
  // with that same math, interpolating between two tiers' icon positions
  // as the cart subtotal moves between their thresholds.
  CartRewardsBar.prototype.iconPosition = function (index) {
    var n = this.tiers.length;
    if (n <= 1) return 100;
    return ((2 * index + 1) / (2 * n)) * 100;
  };

  CartRewardsBar.prototype.fillPercent = function (subtotal) {
    var tiers = this.tiers;
    var n = tiers.length;
    if (!n) return 0;

    if (n === 1) {
      return Math.min(100, (subtotal / tiers[0].threshold_cents) * 100);
    }

    var first = tiers[0];
    var last = tiers[n - 1];

    if (subtotal <= 0) return 0;

    if (subtotal < first.threshold_cents) {
      return this.iconPosition(0) * (subtotal / first.threshold_cents);
    }

    if (subtotal >= last.threshold_cents) {
      return 100;
    }

    for (var i = 0; i < n - 1; i++) {
      var lower = tiers[i];
      var upper = tiers[i + 1];
      if (subtotal >= lower.threshold_cents && subtotal < upper.threshold_cents) {
        var frac = (subtotal - lower.threshold_cents) / (upper.threshold_cents - lower.threshold_cents);
        var lowerPos = this.iconPosition(i);
        var upperPos = this.iconPosition(i + 1);
        return lowerPos + frac * (upperPos - lowerPos);
      }
    }

    return 100;
  };

  CartRewardsBar.prototype.render = function (subtotal) {
    if (this.fillEl) {
      this.fillEl.style.width = this.fillPercent(subtotal) + '%';
    }

    var nextTier = null;
    this.tiers.forEach(function (tier) {
      var unlocked = subtotal >= tier.threshold_cents;
      var tierEl = this.tierEls[tier.id];
      if (tierEl) {
        tierEl.classList.toggle('is-unlocked', unlocked);
      }
      if (!unlocked && !nextTier) {
        nextTier = tier;
      }
    }.bind(this));

    if (!this.messageEl || !this.tiers.length) return;

    if (nextTier) {
      var remaining = nextTier.threshold_cents - subtotal;
      this.messageEl.innerHTML = (this.config.progressTemplate || 'Add {{ amount }} more to get {{ label }}')
        .replace('{{ amount }}', '<strong>' + formatMoney(remaining) + '</strong>')
        .replace('{{ label }}', '<strong>' + nextTier.label + '</strong>');
    } else {
      this.messageEl.innerHTML = this.config.unlockedTemplate || "You've unlocked every reward!";
    }
  };

  CartRewardsBar.prototype.syncGifts = function (cart, subtotal) {
    // Only the designated owner touches the cart, to avoid double-adding
    // gifts when the bar renders in both the drawer and the cart page.
    if (CartRewardsBar.giftOwner !== this) return Promise.resolve();

    var actions = [];

    this.tiers.forEach(function (tier) {
      if (!tier.variant_id) return;

      var unlocked = subtotal >= tier.threshold_cents;
      var existing = cart.items.filter(function (item) {
        return item.properties && item.properties._reward_tier === tier.id;
      })[0];

      if (unlocked && !existing) {
        actions.push(this.addGift(tier));
      } else if (!unlocked && existing) {
        actions.push(this.removeGift(existing));
      }
    }.bind(this));

    if (!actions.length) return Promise.resolve();

    return Promise.all(actions).then(function () {
      document.dispatchEvent(new CustomEvent('cart:build'));
    });
  };

  CartRewardsBar.prototype.addGift = function (tier) {
    var url = routes().cartAdd || '/cart/add.js';
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: tier.variant_id,
        quantity: 1,
        properties: { _reward_tier: tier.id }
      })
    }).catch(function () {});
  };

  CartRewardsBar.prototype.removeGift = function (item) {
    var url = routes().cartChange || '/cart/change.js';
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: item.key, quantity: 0 })
    }).catch(function () {});
  };

  // Clone the hidden source bar into every slot present on the page:
  // the cart drawer (#CartRewardsBarSlot) and the full cart page
  // (#CartRewardsBarSlotCart). Cloning (not moving) lets it appear in both.
  var SLOT_IDS = ['CartRewardsBarSlot', 'CartRewardsBarSlotCart'];

  function placeBars() {
    var template = document.getElementById('CartRewardsBarTemplate');
    if (!template) return;
    var source = template.querySelector('[data-cart-rewards-bar]');
    if (!source) return;

    SLOT_IDS.forEach(function (slotId) {
      var slot = document.getElementById(slotId);
      if (!slot) return;
      if (slot.querySelector('[data-cart-rewards-bar]')) return; // already placed
      slot.innerHTML = '';
      slot.appendChild(source.cloneNode(true));
    });
  }

  function init() {
    placeBars();
    var template = document.getElementById('CartRewardsBarTemplate');
    document.querySelectorAll('[data-cart-rewards-bar]').forEach(function (el) {
      if (template && template.contains(el)) return; // skip the hidden source
      if (el.cartRewardsBarInstance) return;
      el.cartRewardsBarInstance = new CartRewardsBar(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run when the merchant edits this section's settings/blocks in the theme editor.
  document.addEventListener('shopify:section:load', init);
})();
